import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { gql } from 'apollo-boost';
import { get } from 'lodash';
import { theme } from '../../../themes/default-theme';
import RespImg from "../../ui/RespImg";
import NewRadio from '../../forms/NewRadio';
import Text from "../../typography";
import Slider from "react-slick";
import { useMediaQuery } from '@material-ui/core';
import { ReactSVG } from "react-svg";
import chevronLeft from '../../../assets/icons/new-chevron-left.svg';
import chevronRight from '../../../assets/icons/new-chevron-right.svg';
import chevronLeftBig from '../../../assets/icons/model-chevronLeft.svg';
import chevronRightBig from '../../../assets/icons/model-chevronRight.svg';
import NavArrowRight from '../../../assets/icons/new_nav_arrow_right.svg';
import { modelStepsData } from '../../methods/modelStepsData';
import ModelStepsCounter from '../../ui/ModelStepsCounter';
import jaycoClient from '../../../graphql/jaycoClient';
import getModelDataQuery from '../../../graphql/queries/models-floor-plan/model-data';
import { Cta } from "../../ui";
import { setSavedData, getSavedData } from "../../methods/setLocalStorage";
import Link from 'next/link';
import ModelPrice from '../../content/ModelPrice';
import { buildPriceData } from "../../methods/buildPriceDataName";
import { BuildPriceRouteName } from '../../methods/buildPriceRouteName';
import { useInView } from 'react-intersection-observer';
import ModelFooter from '../../content/ModelFooter';
import LoaderIcon from '../../../assets/icons/loader.png';
import getPriceKey from '../../../util/getPriceKey';
import { useRouter } from 'next/router';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled.div`
   max-width: 1400px;
   margin: auto;
   h1 {
    margin-bottom: 20px;
    color: #010101;
    ${theme.breakpoints.up('md')} {
        font-size: 34px;
        padding-top: 37px;
    }   
    ${theme.breakpoints.down('sm')} {
        font-size: 18px;
        padding-top: 25px;
    } 
}
`
const Container = styled.div`
    ${theme.breakpoints.up('md')} {
        padding-bottom: 100px;
        display: flex;
        gap: 60px;
    }
    ul {
        list-style-type: none;
    }
    .slick-slider {
        text-align: center;
    }
    ${theme.breakpoints.up('md')} {
        .slick-dots {
            position: relative;
            margin: 36px auto auto;
            max-width: 1400px;
            width: 100%;
            padding: 0;
            left: 0;
            right: 0;
            > li {
                display: inline-block;
                margin-right: 13px;
                position: relative;
                z-index: 3;
            }
        }
    }
    ${theme.breakpoints.down('sm')} {
        overflow-x: hidden;
        padding-bottom: 60px;
        position: relative;
        .slick-dots {
            text-align: center;
            padding: 0;
            position: relative;
            top: 11px;
            > li {
                display: inline-block;
                margin-right: 13px;
                position: relative;
                z-index: 3;
            }
        }
    }
`
const ActiveImages = styled.div`
    ${theme.breakpoints.down('1500')} {
        > a {
            margin-left: 63px;
        }
    }
    ${theme.breakpoints.up('md')} {
        margin-top: 37px;
        width: 100%;
        overflow: hidden;
        z-index: 5;
        > div {
            margin-top: 70px;
            margin-left: 63px;
            max-width: 703px;
        }
        > a {
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 21px;
            text-transform: uppercase;
            text-decoration: none;
            display: flex;
            align-items: center;
            &:before {
                content: url(${NavArrowRight});
                margin-right: 10px;
                transform: scale(-1);
                filter: brightness(0) saturate(100%) invert(26%) sepia(36%) saturate(4535%) hue-rotate(194deg) brightness(103%) contrast(99%);
            }
        }
    }
`
const ModelHead = styled.div`
    margin: 20px 0;
    color: ${theme.palette.charcoal};
    ${theme.breakpoints.up('md')} {
        h4 {
            font-size: 22px;
            line-height: 22px;
        }
    }
    ${theme.breakpoints.up('lg')} {
        margin: 40px 0 20px;
    }
    ${theme.breakpoints.down('sm')} {
        margin-bottom: 20px;
        h4 {
            font-size: 16px;
            line-height: 22px;
        }
    }
`
const Selections = styled.div`
    width: 100%;
    overflow: hidden;
    label {
        padding: 0 12px;
        background: ${theme.palette.white};
        border-radius: 8px;
    }
    ${theme.breakpoints.up('md')} {
        max-width: 445px;
        max-width: 400px;
        min-width: 400px;
        padding-left: 60px;
        border-left: 1px solid #D9D9D9;
        label {
            height: 50px;
            margin: 0 0 12px;
            span {
                font-size: 17px;
                gap: 16px;
            }
        }
    }
    ${theme.breakpoints.up('992')} {
        max-width: 445px;
    }
    ${theme.breakpoints.down('sm')} {
        margin-bottom: 80px;
        label {
            height: 42px;
            margin: 0 0 12px;
            span {
                font-size: 14px;
                gap: 8px;
            }
        }
        > a {
            font-size: 11px;
            font-style: normal;
            font-weight: 700;
            line-height: 21px;
            padding: 0 12px;
            text-transform: uppercase;
            text-decoration: none;
            display: flex;
            align-items: center;
            margin: 20px 0;
            &:before {
                content: url(${NavArrowRight});
                line-height: 0;
                width: 4px;
                height: auto;
                margin-right: 7px;
                transform: scale(-1);
                filter: brightness(0) saturate(100%) invert(26%) sepia(36%) saturate(4535%) hue-rotate(194deg) brightness(103%) contrast(99%);
            }
        }
    }
`
const SliderDot = styled.div`
    background: ${theme.palette.middleGrey};
    border-radius: 24.5px;
    width: 12px;
    height: 12px;
    cursor: pointer;
    .slick-active & {
        background: #0170D4;
    }
    ${theme.breakpoints.down('sm')} {
        background: ${theme.palette.middleGrey};
    }
`
const NextArrowIcon = styled.div`
    position: absolute;
    width: 8px;
    padding: 0 20px;
    margin: 36px auto auto;
    left: 10px;
    right: 0;
    z-index: 2;
    cursor: pointer;
    ${props => props.sliderCount > 0 && `
        padding-left: ${(props.sliderCount * 12) + (props.sliderCount * 13) + 3}px;
    `}
    svg {
        position: relative;
        path {
            stroke: ${theme.palette.vividBlue};
        }
    }
`
const PrevArrowIcon = styled.div`
    position: absolute;
    width: 8px;
    bottom: 0;
    margin: 36px auto auto;
    padding: 0;
    right: 0;
    z-index: 2;
    cursor: pointer;
    ${props => props.sliderCount > 0 && `
        left: -${(props.sliderCount * 12) + (props.sliderCount * 13) + 25}px;
`}
    svg {
        position: relative;
        top: 1px;
        path {
            stroke: ${theme.palette.vividBlue};
        }
    }
`
const NextArrowIcon2 = styled.div`
    position: absolute;
    padding: 0 20px;
    margin: auto;
    ${theme.breakpoints.up('md')} {
        top: calc(50% - 36px);
    }
    ${theme.breakpoints.down('sm')} {
        top: calc(50% - 36px);
    }
    right: -74px;
    transform: translateY(-50%);
    z-index: 2;
    cursor: pointer;
    svg {
        position: relative;
        top: 1px;
    }
`
const PrevArrowIcon2 = styled.div`
    position: absolute;
    padding: 0;
    margin: auto;
    ${theme.breakpoints.up('md')} {
        top: calc(50% - 36px);
    }
    ${theme.breakpoints.down('sm')} {
        top: calc(50% - 36px);
    }
    left: -56px;
    transform: translateY(-50%);
    z-index: 2;
    cursor: pointer;
    svg {
        position: relative;
        top: 1px;
    }
`
const CounterSection = styled.div`
    ${theme.breakpoints.down('md')} {
        margin-bottom: 60px;
    }
`
const ButtonContainer = styled.div`
    ${theme.breakpoints.down('sm')} {
        padding-top: 8px;
        border-top: 1px solid ${theme.palette.middleGrey};
        width: 100%;
        left: 0;
        padding: 11px 0;
        z-index: 5;
        background: #F3F4F7;
        max-width: 100%;
        position: absolute;
    }
    ${props => props.fixed == 1 && `
        ${theme.breakpoints.down('sm')} {
            position: fixed;
            bottom: 70px;
            padding: 11px 40px;
        }
        ${theme.breakpoints.down('xs')} {
            & {
             padding: 11px 20px;
            }
        }

    `}
    ${props => props.disablePrice == 1 && props.fixed == 1 && `
        ${theme.breakpoints.down('sm')} {
            bottom: 0;
        }
    `}
`

const ModelPriceContainer = styled.div`
    position: fixed;
    width: 100%;
    right: 0;
    z-index: 3;
    ${theme.breakpoints.up('lg')} {
        > div {
            width: 100%;
        }
    }
    ${theme.breakpoints.up('md')} {
        bottom: -4px;
        > div {
            float: right;
        }
    }
    ${theme.breakpoints.down('sm')} {
        bottom: -4px;
        > div {
            width: 100%;
            margin-top: 15px;
        }
    }
    ${props => props.fixed == 1 ? `
        position: fixed;
        ${theme.breakpoints.down('sm')} {
            bottom: 0;
        }
    `: `
        position: absolute;
        ${theme.breakpoints.down('sm')} {
            bottom: -4px;
        }
    `}
    ${theme.breakpoints.up('md')} {
        ${props => props.containerWidth > 0 ? `
            > div {
                min-width: ${400 + props.containerWidth}px;
                max-width: ${400 + props.containerWidth}px;
            }
        `:`
            > div {
                min-width: ${400 + 0}px;
                max-width: ${400 + 0}px;
            }
        `}
    }
    ${theme.breakpoints.up('992')} {
        ${props => props.containerWidth > 0 ? `
            > div {
                min-width: ${445 + props.containerWidth}px;
                max-width: ${445 + props.containerWidth}px;
            }
        `:`
            > div {
                min-width: ${445 + 0}px;
                max-width: ${445 + 0}px;
            }
        `}
    }
`

const ActiveImage = styled.div`
    ${props => props.loading ? `
        display: none;
    `:`
        display: block;
    `}
`
const Loader = styled.div`
    text-align: center;
    align-items: center;
    justify-content: center;
    > img {
        animation: ${rotate} 2s linear infinite;
    }
    ${theme.breakpoints.up('md')} {
        min-height: 300px;
    }
    ${theme.breakpoints.up('lg')} {
        min-height: 464px;
    }
    ${theme.breakpoints.down('sm')} {
        min-height: 22px;
    }
    ${props => props.loading ? `
        display: flex;
    `:`
        display: none;
    `}

`

const InviewContainer = styled.div`
    height: 200px;
    width: 50px;
    position: absolute;
`
const ModelFooterContainer = styled.div`
    ${theme.breakpoints.up('md')} {
        position: relative;
        z-index: 4;
        margin-bottom: 35px;
    }
    ${theme.breakpoints.down('1500')} {
        margin-left: 63px;
        max-width: 40%;
    }
    ${theme.breakpoints.down('sm')} {
        margin-left: 0;
        margin-bottom: 20px;
        max-width: 100%;
        position: relative;
        top: -71px;
    }
`

const ModelSelectModel = (props) => {

    const {
        models,
        seriesName,
        seriesUrl,
        seriesParams,
        modelName,
        modelUrl,
        modelPrice,
        currentWidth,
        dealers,
        countryProps,
        disablePrice
    } = props;

    let res = JSON.parse(getSavedData(buildPriceData)) || {};
    if( res && res.seriesName && seriesName && res.seriesName == seriesName) {
        res = res;
    } else {
        res = {};
    }
    const [selectedModel, setSelectedModel] = useState(null);
    const [floorplan, setFloorplan] = useState(null);
    const [activeModelIndex, setActiveModelIndex] = useState(0);
    const [price, updatePrice] = useState(null);
    const [sliderCount, setSliderCount] = useState(0);
    const [errorSavedData, setErrorSavedData] = useState(null);
    const [selectedOptions, setSelectedOptions] = useState(res?.selectedOptions ? res.selectedOptions : []);
    const [selectedInteriorDecors, setSelectedInteriorDecors] = useState(res?.selectedInteriorDecors ? res.selectedInteriorDecors : {});
    const [currentPrice, setCurrentPrice] = useState(0);
    const [additionalPrice, setAdditionalPrice] = useState(
        res && res.additionalPrice ?
            res.additionalPrice
            : res && res.selectedModelFloorplan && res.selectedModelFloorplan.activeConfiguration && res.selectedModelFloorplan.activeConfiguration.additionalPrice ?
                res.selectedModelFloorplan.activeConfiguration.additionalPrice + 
                parseFloat((res?.selectedInteriorDecors?.activePrice ? res.selectedInteriorDecors.activePrice : 0)) +
                (res?.selectedOptions && res.selectedOptions.length > 0 && res.selectedOptions.map((item) => item.price).reduce((a, b) => a + b, 0))
                : selectedModel?.floorplans.length > 0 && selectedModel?.floorplans[0]?.floorplan?.configurations[0].additionalPrice ?
                    selectedModel.floorplans[0].floorplan.configurations[0].additionalPrice +
                    parseFloat((res?.selectedInteriorDecors?.activePrice ? res.selectedInteriorDecors.activePrice : 0)) +
                    (res?.selectedOptions && res.selectedOptions.length > 0 && res.selectedOptions.map((item) => item.price).reduce((a, b) => a + b, 0))
                    : 0
    );
    const [fixed, setFixed] = useState(true);
    const [getLocation, setGetLocation] = useState(null);
    const [openPostcodePopup, setOpenPostcodePopup] = useState(false);
    const router = useRouter();
    const disabledSteps =  [''];
    const [loading, setLoading] = useState(true);
    // Media Breakpoint Start
    const media = useMediaQuery(theme.breakpoints.up('0'));
    const desktopView = useMediaQuery(theme.breakpoints.up('md'));
    const mobileView = useMediaQuery(theme.breakpoints.down('sm'));
    // Media Breakpoint End

    const radioChangeHandler = (index) => {
        setSelectedModel(models[index]);
        if(((models[index]?.id) == (res?.selectedModel?.id))) {
            setAdditionalPrice(
                (models[index].floorplans[0].floorplan.configurations[0].additionalPrice) +
                parseFloat((res?.selectedInteriorDecors?.activePrice ? res.selectedInteriorDecors.activePrice : 0)) +
                (res?.selectedOptions && res.selectedOptions.length > 0 ? res.selectedOptions.map((item) => item.price).reduce((a, b) => a + b, 0) : 0) -
                0
            )
            setSelectedOptions(res.selectedOptions);
            setSelectedInteriorDecors(res.selectedInteriorDecors);
        } else {
            setAdditionalPrice(
                (models[index].floorplans[0].floorplan.configurations[0].additionalPrice) +
                0
            )
            setSelectedOptions([])
            setSelectedInteriorDecors({});
        }
        setFloorplan(models[index].floorplans[0].floorplan)
        setActiveModelIndex(index);
        setCurrentPrice(
                price
        )
    };

    const openPostcode = (e) => {
        e.preventDefault();
        setOpenPostcodePopup(!openPostcodePopup);
    }

    const getCurrentSetLocation = (currentLocation) => {
        setGetLocation(currentLocation)
    }

    const onLoad = () => {
        setLoading(false);
    };

    const handleSaveData = () => {
      
        if (selectedModel && Object.values(selectedModel).length > 0 && res && res.seriesName && seriesName && res.seriesName != seriesName) {
            res = {};
            res.seriesName = seriesName;
            res.modelParams = selectedModel.floorplans[0].uri
            res.selectedModel = selectedModel;
            res.currentPrice = currentPrice;
            res.additionalPrice = additionalPrice;
            res.selectedOptions = selectedOptions;
            res.selectedInteriorDecors = selectedInteriorDecors;
            if(res.selectedModelFloorplan && res.selectedModelFloorplan.activeFloorPlanModel && res.selectedModelFloorplan.activeConfiguration) {
                res.selectedModelFloorplan = {
                    activeFloorPlanModel: selectedModel.floorplans[0],
                    activeConfiguration: selectedModel?.floorplans.length > 0 && selectedModel.floorplans[0]?.floorplan.configurations[0],
                    activeModelIndex: activeModelIndex
                }
                if(res.selectedModelFloorplan.activeFloorPlanModel?.floorplan && price) {
                    res.selectedModelFloorplan.activeFloorPlanModel.floorplan = price
                }
                
            }
            setSavedData(
                buildPriceData,
                JSON.stringify(
                    res
                ),
                86400 // 1 day
            );
        } else if (selectedModel && Object.values(selectedModel).length > 0 && (res.selectedModel && res.selectedModel.name && res.selectedModel.name == selectedModel.name)) {
            res.selectedModel = selectedModel;
            res.seriesName = seriesName && seriesName;
            res.modelParams =  selectedModel.name == (res.selectedModel?.name && res.selectedModel.name) ? res.modelParams : selectedModel.floorplans[0].uri
            res.currentPrice = currentPrice;
            res.additionalPrice = additionalPrice;
            res.selectedOptions = selectedOptions;
            res.selectedInteriorDecors = selectedInteriorDecors;
            if(res.selectedModelFloorplan && res.selectedModelFloorplan.activeFloorPlanModel && res.selectedModelFloorplan.activeConfiguration)  {
                res.selectedModelFloorplan = {
                    ...res.selectedModelFloorplan,
                    activeModelIndex: activeModelIndex
                }
            }
            setSavedData(
                buildPriceData,
                JSON.stringify(
                    res
                ),
                86400 // 1 day
            );
        } else if (selectedModel && Object.values(selectedModel).length > 0) {
            res.selectedModel = selectedModel;
            res.seriesName = seriesName && seriesName;
            res.currentPrice = currentPrice;
            res.additionalPrice = additionalPrice;
            res.selectedOptions = selectedOptions;
            res.selectedInteriorDecors = selectedInteriorDecors;
            (
                res.selectedModelFloorplan = {
                    activeFloorPlanModel: selectedModel.floorplans[0],
                    activeConfiguration: selectedModel?.floorplans.length > 0 && selectedModel.floorplans[0]?.floorplan.configurations[0],
                    activeModelIndex: activeModelIndex
                }
            )
            setSavedData(
                buildPriceData,
                JSON.stringify(
                    res
                ),
                86400 // 1 day
            );
        } else {
            setErrorSavedData('There is option missing')
        }
        setSavedData(
            BuildPriceRouteName,
            router?.pathname && router.pathname,
            7200 // 2 hours
        );  
    }

    function SampleNextArrow(props) {
        const { onClick } = props;
        return (
            <>
                {desktopView &&
                    <NextArrowIcon onClick={onClick} sliderCount={sliderCount}>
                        <ReactSVG src={chevronRight} />
                    </NextArrowIcon>
                }
                <NextArrowIcon2 onClick={onClick}>
                    <ReactSVG src={chevronRightBig} />
                </NextArrowIcon2>
            </>

        );
    }

    function SamplePrevArrow(props) {
        const { onClick } = props;
        return (
            <>
                {desktopView &&
                    <PrevArrowIcon onClick={onClick} sliderCount={sliderCount}>
                        <ReactSVG src={chevronLeft} />
                    </PrevArrowIcon>
                }
                <PrevArrowIcon2 onClick={onClick}>
                    <ReactSVG src={chevronLeftBig} />
                </PrevArrowIcon2>
            </>

        );
    }

    useEffect(() => {
        setSelectedModel(
            models && models.length > 0 && models.length > 1 && res && res.selectedModel && models.some((item) => item.id == res.selectedModel.id) ? res.selectedModel : models && models.length > 0 ? models[0] : {}
        )
    }, [models])

    useEffect(() => {
        selectedModel && selectedModel.images?.length && setSliderCount(selectedModel.images.length);
        setFloorplan(
            res && res.selectedModelFloorplan && res.selectedModelFloorplan.activeFloorplanIndex && selectedModel?.floorplans && selectedModel.floorplans.length > 0 && res.selectedModel.id.toLowerCase() == selectedModel.id.toLowerCase() ? selectedModel.floorplans[res.selectedModelFloorplan.activeFloorplanIndex] : selectedModel?.floorplans.length > 0 && selectedModel.floorplans[0]
        )

        
    }, [selectedModel])

    useEffect(() => {

        const getData = async () => {
            //   setLoading(true);

            const GET_MODEL_DATA = gql`
            ${getModelDataQuery}
          `

            const result = (floorplan && floorplan.floorplan && floorplan.floorplan.floorplanId) ? await jaycoClient.query({
                query: GET_MODEL_DATA,
                variables: {
                    id: floorplan.floorplan.floorplanId
                }
            }) : {};

            const key = getLocation?.data?.contact ? getPriceKey(getLocation.data.contact) : getPriceKey();
            if (key) {
                const priceVal = result.data && result.data.getModel ? result.data.getModel[key] : 0; // get(result, `data.getModel[${pricingKey}]`, null);
                priceVal && priceVal > 0 && updatePrice(priceVal);
            } else {
                router.push(seriesUrl?.link?.href && seriesUrl.link.href)
            }
        }

        getData();

    }, [floorplan]);

    useEffect(() => {
        setCurrentPrice(
                 price ?
                    price
                    : 0
        )
    }, [price])

    var settings = {
        customPaging: function (i) {
            return (
                <SliderDot />
            );
        },
        dots: true,
        infinite: true,
        fade: true,
        speed: 100,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />
    };


    const { ref, inView, entry } = useInView({
        /* Optional options */
        threshold: 0
      });

    useEffect(() => {
        const handleScroll = (e) => {
             if ((!inView)) {
                setFixed(true)
            } else {
                setFixed(false)
            }
        }
        setTimeout(() => {
        handleScroll();
        }, 300)
        window.addEventListener("resize", handleScroll);
        return () => {
             window.removeEventListener("resize", handleScroll);
        }

    }, [inView && inView, media]);
    
    // console.log('res select model', res && res)
 
    return (
        <Wrapper>
            {seriesName && mobileView &&
                <Text variant="h1" weight={800} uppercase>{seriesName.indexOf('Jayco') > -1 ? seriesName : `Jayco ${seriesName}`}</Text>
            }
            {mobileView &&
                <CounterSection>
                    <ModelStepsCounter
                        modelStepsData={modelStepsData(seriesUrl && seriesUrl.link && seriesUrl.link.href, floorplan?.uri ? floorplan.uri : selectedModel.floorplans[0].uri, disabledSteps, 1)}
                        handleSaveData={handleSaveData}
                    />
                </CounterSection>
            }
            <Container>
                <ActiveImages>
                    {desktopView &&
                        <Link href={seriesUrl && seriesUrl.link && seriesUrl.link.href ? seriesUrl && seriesUrl.link && seriesUrl.link.href : '#'}>
                            <a>
                                Back
                            </a>
                        </Link>
                    }
                    <Slider {...settings}>
                        {selectedModel && selectedModel.images && selectedModel.images.map((item, index) => {
                            return (
                                <>
                                    <Loader loading={loading}>
                                        <img src={LoaderIcon} alt="loader" />
                                    </Loader>
                                    <ActiveImage key={index} onLoad={onLoad}>
                                        <RespImg
                                            // loading={loading}
                                            {...item.image}
                                        />
                                    </ActiveImage>
                                </>
                            )
                        })
                        }
                    </Slider>
                </ActiveImages>
                {
                    models && models.length > 0 &&
                    <>
                        <Selections>
                            {seriesName && desktopView &&
                                <Text variant="h1" weight={800} uppercase>{seriesName.indexOf('Jayco') > -1 ? seriesName : `Jayco ${seriesName}`}</Text>
                            }
                            {desktopView &&
                                <CounterSection>
                                    <ModelStepsCounter
                                        modelStepsData={modelStepsData(seriesUrl && seriesUrl.link && seriesUrl.link.href, floorplan?.uri ? floorplan.uri  : selectedModel.floorplans[0].uri, disabledSteps, 1)}
                                        handleSaveData={handleSaveData}
                                    />
                                </CounterSection>
                            }
                            <ModelHead>
                                <Text variant="h4" weight={700}>Select a model</Text>
                            </ModelHead>
                            {models.map((item, index) => {
                                return (
                                    <NewRadio
                                        key={item.id ? item.id : index}
                                        changed={() => radioChangeHandler(index)}
                                        id={item.id ? item.id : index}
                                        isSelected={selectedModel?.id?.toString().toLowerCase() == models[index].id.toString().toLowerCase()}
                                        label={item.name}
                                        value={item.id}
                                        showOptionLabel={true}
                                        showLabelOnly={true}
                                        flex={true}
                                        borderStyle={true}
                                    />
                                )
                            })}
                            {mobileView &&
                                <Link href={seriesUrl && seriesUrl.link && seriesUrl.link.href ? seriesUrl && seriesUrl.link && seriesUrl.link.href : '#'}>
                                    <a>
                                        Back
                                    </a>
                                </Link>
                            }
                                <ButtonContainer fixed={fixed ? 1 : 0} disablePrice={props.disablePrice ? 1 : 0}>
                                    <Link  href={seriesUrl && seriesUrl.link && seriesUrl.link.href ? `${seriesUrl.link.href}/floorplan` : '#'}>
                                        <a onClick={handleSaveData}>
                                            <Cta>Next</Cta>
                                        </a>
                                        </Link>
                                </ButtonContainer>
      
                        </Selections>

                    </>
                }
            </Container>
            {!disablePrice && modelPrice &&
                <>
                <ModelPriceContainer containerWidth={currentWidth > 0 ? currentWidth : 0} fixed={fixed ? 1 : 0}>
                    <ModelPrice
                        price={currentPrice}
                        additionalPrice={additionalPrice}
                        rates={modelPrice.rates}
                    // buildUrl={}
                    // country={}
                    />
                </ModelPriceContainer>
                </>
            }
            <InviewContainer ref={ref}>

            </InviewContainer>
            <ModelFooterContainer>
                <ModelFooter
                    dealers={dealers}
                    countryProps={countryProps}
                    getCurrentSetSetLocation={getCurrentSetLocation}
                    openPostcodePopup={openPostcodePopup}
                    setOpenPostcodePopup={setOpenPostcodePopup}
                    staticData={true}
                />
            </ModelFooterContainer>
        </Wrapper>
    );

}

ModelSelectModel.propTypes = {
    models: propTypes.array,
    seriesName: propTypes.string,
    seriesUrlL: propTypes.object,
    seriesParams: propTypes.string,
    modelName: propTypes.string,
    modelUrl: propTypes.string,
    modelPrice: propTypes.object,
    currentWidth: propTypes.number,
    dealers: propTypes.array,
    countryProps: propTypes.object,
    disablePrice: propTypes.bool
};

ModelSelectModel.defaultProps = {
    models: [],
    seriesName: null,
    seriesUrl: {},
    seriesParams: null,
    modelName: null,
    modelUrl: null,
    modelPrice: {},
    currentWidth: null,
    dealers: [],
    countryProps: {},
    disablePrice: true
}

export default ModelSelectModel;